﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customMenu from './tpl/customMenu.html';
import Help from '../../../helper/help';
import AuthHelper from '../../../helper/auth';

export default Marionette.LayoutView.extend({
    initialize: function () {
        this.app = this.options.app;

        var userChannel = Backbone.Radio.channel('app');

        var self = this;
        //userChannel.on('customMenu:enable', function() {
        //    self.options.enable = true;
        //    self.initMenu(true);
        //});
        this.listenTo(userChannel, 'customMenu:enable', function () {
            self.options.enable = true;
            self.initMenu(true);
        });

        //userChannel.on('customMenu:disable', function() {
        //    self.options.enable = false;
        //    self.initMenu(false);
        //});
        this.listenTo(userChannel, 'customMenu:disable', function () {
            self.options.enable = false;
            self.initMenu(false);
        });

        userChannel.on('CustomMenu:setLoginName', function () {
            //if (self.app.mgr.profile !== undefined) {
            //    var events4usUser_FirstName = self.app.entities.models.custom.attributes.FirstName;
            //    var events4usUser_AttPerson = self.app.entities.models.custom.attributes.AttPerson;
            //    var events4usUser_Organisation = self.app.entities.models.custom.attributes.Organisation;

            //    /*
            //    var events4usUser_FirstName = localStorage.getItem('events4usUser_FirstName');
            //    var events4usUser_AttPerson = localStorage.getItem('events4usUser_AttPerson');
            //    var events4usUser_Organisation = localStorage.getItem('events4usUser_Organisation');
            //    */

            //    /*                var events4usUser_FirstName = localStorage.getItem('events4usUser_FirstName');
            //                    var events4usUser_AttPerson = localStorage.getItem('events4usUser_AttPerson');
            //                    var events4usUser_Organisation = localStorage.getItem('events4usUser_Organisation');
            //                    */
            //    var displayName = events4usUser_FirstName;

            //    switch (events4usUser_Organisation) {
            //        case 0: displayName = events4usUser_FirstName; break;
            //        case 1: displayName = events4usUser_AttPerson; break;
            //        case 2: displayName = events4usUser_AttPerson; break;
            //    }

            //    var displayOrg = '';
            //    switch (events4usUser_Organisation) {
            //        case 0: displayOrg = resources['X100574']; break;
            //        case 1: displayOrg = resources['X100575']; break;
            //        case 2: displayOrg = resources['X100576']; break;
            //    }

            //    if (displayName.length <= 0) {
            //        self.ui.custom_menu_loginName.html('');
            //        self.ui.custom_menu_loginOrg.html('');
            //    } else {
            //        var userTag = displayName;
            //        self.$el.find('#custom_menu_loginName').html(displayName);
            //        self.$el.find('#custom_menu_loginOrg').html(displayOrg);
            //        //self.ui.custom_menu_loginName.html(displayName);
            //        //self.ui.custom_menu_loginOrg.html(displayOrg);
            //    }
            //}

            var events4usUser_FirstName = self.app.entities.models.custom.attributes.Name;
            var displayName = events4usUser_FirstName;
            if (displayName.length >= 0) {
                self.$el.find('#custom_menu_loginName').html(displayName);
            }
            else {
                //self.ui.custom_menu_loginName.css('display', 'none');
                //self.ui.custom_menu_loginOrg.css('display', 'none');
            }
        });
    },
    help: function () {
        Help.help(this, true, 'gettingStarted');
    },
    getTemplate: function () {
        return tpl_customMenu();
    },
    ui: {
        'custom_menu_btnAuth': '#custom_menu_btnAuth',
        'custom_menu_btnAuthLogoff': '#custom_menu_btnAuthLogoff',
        'custom_menu_CustomSetting': '#custom_menu_CustomSetting',
        'custom_menu_loginName': '#custom_menu_loginName',
        'custom_menu_loginOrg': '#custom_menu_loginOrg',
        'custom_menu_profileImage': '#custom_menu_profileImage',
        'helpMenuEvent_i': '#helpMenuEvent_i',
        'helpMenuDesign_i': '#helpMenuDesign_i',
        'helpMenuInformation_i': '#helpMenuInformation_i',
        'menu1': '#custom_menu1_a',
        'menu2': '#custom_menu2_a',
        'menu3': '#custom_menu3_a',
        'menu4': '#custom_menu4_a',
        'menu5': '#custom_menu5_a',
        'menu6': '#custom_menu6_a',
        'menu7': '#custom_menu7_a',
        'menu8': '#custom_menu8_a',
        'menu9': '#custom_menu9_a',
        'menu10': '#custom_menu10_a',
        'menu11': '#custom_menu11_a',
        'menu12': '#custom_menu12_a',
        'menu13': '#custom_menu13_a',
        'menu14': '#custom_menu14_a',
        'menu15': '#custom_menu15_a',
        'menu16': '#custom_menu16_a',
        'menu17': '#custom_menu17_a',
        'menu18': '#custom_menu18_a',
        'menu19': '#custom_menu19_a',
        'menu20': '#custom_menu20_a',
        'customMenuSideMenu01': '#customMenuSideMenu01',
        'customMenuSideMenu02': '#customMenuSideMenu02',
        'customMenuSideMenu03': '#customMenuSideMenu03',
        'custom_menu_AdImage_a': '#custom_menu_AdImage_a'
    },
    events: {
        'click @ui.custom_menu_btnAuth': 'custom_menu_btnAuthClick',
        'click @ui.custom_menu_btnAuthLogoff': 'custom_menu_btnAuthLogoffClick',
        'click @ui.custom_menu_CustomSetting': 'custom_menu_CustomSettingClick',
        'click #custom_menu11_a': 'help',
        'click #helpMenuEvent_i': 'helpMenuEvent',
        'click #helpMenuDesign_i': 'helpMenuDesign',
        'click #helpMenuInformation_i': 'helpMenuInformation',
        'click #customMenuSideMenu01': 'helpMenuEvent',
        'click #customMenuSideMenu02': 'helpMenuDesign',
        'click #customMenuSideMenu03': 'helpMenuInformation',
    },
    onRender: function () {
        this.initMenu(this.options.enable);
        this.renderLoginName();

        if (this.app.mode == 1) {
            //this.ui.custom_menu1_a.css('display', 'none');
            this.ui.menu2.css('display', 'none');
            this.ui.menu3.css('display', 'none');
            //this.ui.custom_menu4_a.css('display', 'none');
            this.ui.menu5.css('display', 'none');
            this.ui.menu6.css('display', 'none');
            this.ui.menu7.css('display', 'none');
            this.ui.menu8.css('display', 'none');
            this.ui.menu9.css('display', 'none');
            this.ui.menu10.css('display', 'none');
            //this.ui.custom_menu11_a.css('display', 'none');
            //this.ui.custom_menu12_a.css('display', 'none');
            //this.ui.custom_menu13_a.css('display', 'none');
            this.ui.menu14.css('display', 'none');
            this.ui.menu15.css('display', 'none');
            this.ui.menu16.css('display', 'none');
            this.ui.menu17.css('display', 'none');
            this.ui.menu18.css('display', 'none');
            this.ui.menu19.css('display', 'none');
            this.ui.menu20.css('display', 'none');
        }
    },
    onAttach() {
        //if (this.app.mgr.profile !== undefined) {
        //    this.ui.custom_menu_btnAuth.css('display', 'none');
        //    this.ui.custom_menu_btnAuthLogoff.show();
        //    this.ui.custom_menu_loginName.show();
        //    this.ui.custom_menu_loginOrg.show();
        //} else {
        //    this.ui.custom_menu_btnAuth.show();
        //    this.ui.custom_menu_btnAuthLogoff.css('display', 'none');
        //    this.ui.custom_menu_loginName.css('display', 'none');
        //    this.ui.custom_menu_loginOrg.css('display', 'none');
        //}

        this.renderLoginName();
        //var userChannel = Backbone.Radio.channel('app');
        //userChannel.trigger('CustomMenu:setLoginName');
    },
    renderLoginName: function () {
        var self = this;
        this.$el.find('#custom_menu_loginName').html(this.model.attributes.Name);
        this.$el.find('#custom_menu_loginOrg').html("");

        var nameArray = this.model.attributes.Name.split(' ', 4);
        var intials = '';

        if (nameArray.length > 0) intials += nameArray[0].charAt(0).toUpperCase();
        if (nameArray.length > 1) intials += nameArray[1].charAt(0).toUpperCase();
        if (nameArray.length > 2) intials += nameArray[2].charAt(0).toUpperCase();
        if (nameArray.length > 3) intials += nameArray[3].charAt(0).toUpperCase();

        this.ui.custom_menu_profileImage.text(intials);
        //if (self.app.mgr.profile !== undefined) {

        //    var events4usUser_FirstName = self.app.entities.models.custom.attributes.FirstName;
        //    var events4usUser_AttPerson = self.app.entities.models.custom.attributes.AttPerson;
        //    var events4usUser_Organisation = self.app.entities.models.custom.attributes.Organisation;

        //    /*
        //    var events4usUser_FirstName = localStorage.getItem('events4usUser_FirstName');
        //    var events4usUser_AttPerson = localStorage.getItem('events4usUser_AttPerson');
        //    var events4usUser_Organisation = localStorage.getItem('events4usUser_Organisation');
        //    */

        //    /*                var events4usUser_FirstName = localStorage.getItem('events4usUser_FirstName');
        //                    var events4usUser_AttPerson = localStorage.getItem('events4usUser_AttPerson');
        //                    var events4usUser_Organisation = localStorage.getItem('events4usUser_Organisation');
        //                    */
        //    var displayName = events4usUser_FirstName;

        //    switch (events4usUser_Organisation) {
        //        case 0: displayName = events4usUser_FirstName; break;
        //        case 1: displayName = events4usUser_AttPerson; break;
        //        case 2: displayName = events4usUser_AttPerson; break;
        //    }

        //    var displayOrg = '';
        //    switch (events4usUser_Organisation) {
        //        case 0: displayOrg = resources['X100574']; break;
        //        case 1: displayOrg = resources['X100575']; break;
        //        case 2: displayOrg = resources['X100576']; break;
        //    }

        //    if (displayName.length <= 0) {
        //        self.ui.custom_menu_loginName.html('');
        //        self.ui.custom_menu_loginOrg.html('');
        //    } else {
        //        var userTag = displayName;
        //        self.$el.find('#custom_menu_loginName').html(displayName);
        //        self.$el.find('#custom_menu_loginOrg').html(displayOrg);
        //        //self.ui.custom_menu_loginName.html(displayName);
        //        //self.ui.custom_menu_loginOrg.html(displayOrg);
        //    }
        //} else {
        //    self.ui.custom_menu_loginName.css('display', 'none');
        //    self.ui.custom_menu_loginOrg.css('display', 'none');
        //}
    },
    custom_menu_btnAuthClick: function (event) {
        if (event) {
            event.preventDefault();
        }

        window.mgr.redirectForToken().then(function () {
            //alert('Success: ');
        }, function (err) {
            //alert('Error: ');
        });
    },
    custom_menu_btnAuthLogoffClick: function (event) {
        event.preventDefault();

        AuthHelper.logout(this.app);
    },
    custom_menu_CustomSettingClick: function (event) {
        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('Region_Header:customerSetting');
    },
    initMenu: function (enable) {
        enable = true;
        var color = enable ? '#001737' : '#a0a0a0';
        var pointer_events_value = enable ? '' : 'none';
        var cursor_value = enable ? 'pointer' : 'not-allowed';

        //this.ui.menu1.attr('enable', enable);
        //this.ui.menu1.css('pointer-events', pointer_events_value);
        //this.ui.menu1.css('color', color);
        //this.ui.menu2.attr('enable', enable);
        //this.ui.menu2.css('pointer-events', pointer_events_value);
        //this.ui.menu2.css('color', color);
        //this.ui.menu3.attr('enable', enable);
        //this.ui.menu3.css('pointer-events', pointer_events_value);
        //this.ui.menu3.css('color', color);
        //this.ui.menu4.attr('enable', enable);
        //this.ui.menu4.css('pointer-events', pointer_events_value);
        //this.ui.menu4.css('color', color);
        //this.ui.menu5.attr('enable', enable);
        //this.ui.menu5.css('pointer-events', pointer_events_value);
        //this.ui.menu5.css('color', color);
        //this.ui.menu6.attr('enable', enable);
        //this.ui.menu6.css('pointer-events', pointer_events_value);
        //this.ui.menu6.css('color', color);
        //this.ui.menu7.attr('enable', enable);
        //this.ui.menu7.css('pointer-events', pointer_events_value);
        //this.ui.menu7.css('color', color);
        //this.ui.menu8.attr('enable', enable);
        //this.ui.menu8.css('pointer-events', pointer_events_value);
        //this.ui.menu8.css('color', color);
        //this.ui.menu9.attr('enable', enable);
        //this.ui.menu9.css('pointer-events', pointer_events_value);
        //this.ui.menu9.css('color', color);
        //this.ui.menu10.attr('enable', enable);
        //this.ui.menu10.css('pointer-events', pointer_events_value);
        //this.ui.menu10.css('color', color);
        //this.ui.menu11.attr('enable', enable);
        //this.ui.menu11.css('pointer-events', pointer_events_value);
        //this.ui.menu11.css('color', color);
        //this.ui.menu12.attr('enable', enable);
        //this.ui.menu12.css('pointer-events', pointer_events_value);
        //this.ui.menu12.css('color', color);
        //this.ui.menu13.attr('enable', enable);
        //this.ui.menu13.css('pointer-events', pointer_events_value);
        //this.ui.menu13.css('color', color);
        //this.ui.menu14.attr('enable', enable);
        //this.ui.menu14.css('pointer-events', pointer_events_value);
        //this.ui.menu14.css('color', color);

        this.$el.find('#custom_menu1_a').attr('enable', enable);
        this.$el.find('#custom_menu1_a').attr('disabled', !enable);
        this.$el.find('#custom_menu1_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu1_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu1_a').css('color', color);
        this.$el.find('#custom_menu2_a').attr('enable', enable);
        this.$el.find('#custom_menu2_a').attr('disabled', !enable);
        this.$el.find('#custom_menu2_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu2_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu2_a').css('color', color);
        this.$el.find('#custom_menu3_a').attr('enable', enable);
        this.$el.find('#custom_menu3_a').attr('disabled', !enable);
        this.$el.find('#custom_menu3_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu3_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu3_a').css('color', color);
        this.$el.find('#custom_menu4_a').attr('enable', enable);
        this.$el.find('#custom_menu4_a').attr('disabled', !enable);
        this.$el.find('#custom_menu4_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu4_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu4_a').css('color', color);
        this.$el.find('#custom_menu5_a').attr('enable', enable);
        this.$el.find('#custom_menu5_a').attr('disabled', !enable);
        this.$el.find('#custom_menu5_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu5_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu5_a').css('color', color);
        this.$el.find('#custom_menu6_a').attr('enable', enable);
        this.$el.find('#custom_menu6_a').attr('disabled', !enable);
        this.$el.find('#custom_menu6_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu6_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu6_a').css('color', color);
        this.$el.find('#custom_menu7_a').attr('enable', enable);
        this.$el.find('#custom_menu7_a').attr('disabled', !enable);
        this.$el.find('#custom_menu7_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu7_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu7_a').css('color', color);
        this.$el.find('#custom_menu8_a').attr('enable', enable);
        this.$el.find('#custom_menu8_a').attr('disabled', !enable);
        this.$el.find('#custom_menu8_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu8_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu8_a').css('color', color);
        this.$el.find('#custom_menu9_a').attr('enable', enable);
        this.$el.find('#custom_menu9_a').attr('disabled', !enable);
        this.$el.find('#custom_menu9_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu9_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu9_a').css('color', color);
        this.$el.find('#custom_menu10_a').attr('enable', enable);
        this.$el.find('#custom_menu10_a').attr('disabled', !enable);
        this.$el.find('#custom_menu10_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu10_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu10_a').css('color', color);
        this.$el.find('#custom_menu11_a').attr('enable', enable);
        this.$el.find('#custom_menu11_a').attr('disabled', !enable);
        this.$el.find('#custom_menu11_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu11_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu11_a').css('color', color);
        this.$el.find('#custom_menu12_a').attr('enable', enable);
        this.$el.find('#custom_menu12_a').attr('disabled', !enable);
        this.$el.find('#custom_menu12_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu12_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu12_a').css('color', color);
        this.$el.find('#custom_menu13_a').attr('enable', enable);
        this.$el.find('#custom_menu13_a').attr('disabled', !enable);
        this.$el.find('#custom_menu13_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu13_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu13_a').css('color', color);
        this.$el.find('#custom_menu14_a').attr('enable', enable);
        this.$el.find('#custom_menu14_a').attr('disabled', !enable);
        this.$el.find('#custom_menu14_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu14_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu14_a').css('color', color);
        this.$el.find('#custom_menu15_a').attr('enable', enable);
        this.$el.find('#custom_menu15_a').attr('disabled', !enable);
        this.$el.find('#custom_menu15_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu15_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu15_a').css('color', color);
        this.$el.find('#custom_menu16_a').attr('enable', enable);
        this.$el.find('#custom_menu16_a').attr('disabled', !enable);
        this.$el.find('#custom_menu16_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu16_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu16_a').css('color', color);
        this.$el.find('#custom_menu17_a').attr('enable', enable);
        this.$el.find('#custom_menu17_a').attr('disabled', !enable);
        this.$el.find('#custom_menu17_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu17_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu17_a').css('color', color);
        this.$el.find('#custom_menu18_a').attr('enable', enable);
        this.$el.find('#custom_menu18_a').attr('disabled', !enable);
        this.$el.find('#custom_menu18_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu18_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu18_a').css('color', color);
        this.$el.find('#custom_menu19_a').attr('enable', enable);
        this.$el.find('#custom_menu19_a').attr('disabled', !enable);
        this.$el.find('#custom_menu19_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu19_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu19_a').css('color', color);
        this.$el.find('#custom_menu20_a').attr('enable', enable);
        this.$el.find('#custom_menu20_a').attr('disabled', !enable);
        this.$el.find('#custom_menu20_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu20_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu20_a').css('color', color);
        this.$el.find('#custom_menu21_a').attr('enable', enable);
        this.$el.find('#custom_menu21_a').attr('disabled', !enable);
        this.$el.find('#custom_menu21_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu21_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu21_a').css('color', color);
        this.$el.find('#custom_menu22_a').attr('enable', enable);
        this.$el.find('#custom_menu22_a').attr('disabled', !enable);
        this.$el.find('#custom_menu22_a').css('cursor', cursor_value);
        this.$el.find('#custom_menu22_a').css('pointer-events', pointer_events_value);
        this.$el.find('#custom_menu22_a').css('color', color);
    },
    helpMenuEvent: function () {
        Help.help(this, true, 'menuEvent');
    },
    helpMenuDesign: function () {
        Help.help(this, true, 'menuDesign');
    },
    helpMenuInformation: function () {
        Help.help(this, true, 'menuInformation');
    }
}, Backbone.Radio.Requests);
